import { Injectable } from '@angular/core';
import { firstValueFrom, map, Observable, of, tap, zip } from 'rxjs';
import { ReactiveList } from '@dg/shared-rsm';
import { SearchDataService } from './search.data-service';
import { SearchLearningResponse, SearchState } from './models';
import {
  applyEndorsedFacet,
  getEndorsedPagination,
  stateToLearningOptions,
} from './utils';
import { LearningResourceViewModel } from '@app/inputs/models/learning-resource.view-model';

@Injectable()
export class SearchEndorsedFacade {
  public endorsedLearnings = new ReactiveList<LearningResourceViewModel>(
    'endorsedLearnings'
  );

  constructor(private searchDataService: SearchDataService) {}

  public async getEndorsedLearnings(
    state: SearchState,
    reset: boolean = false
  ): Promise<SearchLearningResponse> {
    const { count, skip } = await firstValueFrom(this.getPagination(reset));
    const appliedFacets = applyEndorsedFacet(state?.appliedFacets);
    const learningOptions = stateToLearningOptions({ ...state, appliedFacets });

    return firstValueFrom(
      this.searchDataService
        .loadEndorsedLearnings(learningOptions, count, skip)
        .pipe(
          this.endorsedLearnings.trackLoadStatus,
          tap(({ results, total }) => {
            this.endorsedLearnings.addItems(results, reset, total);
            this.endorsedLearnings.setLoading(false);
          })
        )
    );
  }

  private getPagination(reset: boolean): Observable<EndorsedPagination> {
    return zip(this.endorsedLearnings.list$, of(reset)).pipe(
      map(getEndorsedPagination)
    );
  }
}

export interface EndorsedPagination {
  count: number;
  skip: number;
}
